const GENERIC_MESSAGE = 'There was a problem processing that request.';

/**
 * Error bodies arrive from these APIs in three shapes, plus callers that pass
 * a bare string:
 *   ProblemDetails  { title, detail, status, instance, errors }  framework / BusinessException
 *   WrappedError    { message, statusCode, correlationId }       ErrorHandlerMiddleware
 *   none            ''                                          bare NotFound() / BadRequest()
 */
function normalizeErrorBody(input) {
    const body = typeof input === 'string' ? { detail: input } : input ?? {};
    return {
        title: body.title ?? null,
        message: body.detail ?? body.message ?? null,
        status: body.status ?? body.statusCode ?? null,
        errorId: body.errorId ?? body.status ?? body.statusCode ?? null,
        correlationId: body.correlationId ?? null,
        instance: body.instance ?? null,
        errors: body.errors ?? null,
    };
}

class ApiError extends Error {
    constructor(input) {
        const b = normalizeErrorBody(input);
        super(b.message ?? GENERIC_MESSAGE);
        // Creates stack prop

        this.name = 'ApiError';
        this.title = b.title;
        this.message = b.message ?? GENERIC_MESSAGE;
        this.errorCode = b.status;
        this.errorId = b.errorId;
        this.correlationId = b.correlationId;
        if (b.instance) this.instance = b.instance;
        if (b.errors) this.errors = b.errors;
    }

    static UnwrappedError(title, msg, location) {
        const err = new ApiError(msg);
        err.title = title;
        err.message = msg;
        err.instance = location;
        return err;
    }

    static ApiFormattedError(errorResponse) {
        const formattedError = new ApiError(errorResponse);
        formattedError.errorId = errorResponse.status;
        formattedError.title = errorResponse.statusText;
        formattedError.message = errorResponse.data;
        return formattedError;
    }

    static InvoiceError(errorResponse) {
        const formattedError = new ApiError(errorResponse);
        formattedError.errorId = errorResponse.status;
        formattedError.message = errorResponse.data.userMessage;
        formattedError.errors = errorResponse.data.errors;
        return formattedError;
    }
}

export { ApiError };
